module.exports = __webpack_public_path__ + "img/1717485782449-WhatsApp Image 2024-06-04 at 14.06.07.jpeg.447873b1.webp";